// ----------------------------------------------------------------------
// <copyright file="Izenda.FormSearchPopup.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Form Search Popup component
 */
!(function() {
  var React = require('react');
  var EventsUtils = require('EventUtils');
  var Input = require('share/components/controls/Izenda.Input');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Popup = require('share/components/controls/CommonPopup/Izenda.Popup');
  var Alert = require('share/components/controls/Izenda.Alert');
  var Constants = require('logic/data/Izenda.ReportPartFormConstants');
  var connect = require('share/enhancers/Izenda.Connect');
  var { isNil } = require('lodash/fp');

  var FormSearchPopup = React.createClass({
    propTypes: {
      onChange: React.PropTypes.func
    },

    getInitialState: function() {
      return this.setupPopupState();
    },

    setupPopupState: function() {
      return {
        message: '',
        searchText: '',
        replaceText: '',
        activePopup: false
      };
    },

    handleClick: function(type) {
      var editorControl = this.props.editorControl;
      var state = this.state;
      var message = '';

      if (isNil(state.searchText)) {
        return;
      }

      if (type === 'searchCode' && editorControl.searchCode(state.searchText) === false) {
        message = Constants.MESSAGES.M10;
      } else if (type === 'replaceCode' && editorControl.replaceCode(state.searchText, state.replaceText) === false) {
        message = Constants.MESSAGES.M11;
      }

      if (this.state.message !== message) {
        this.setState({ message: message });
      }
    },

    renderPopupContent: function() {
      var localization = this.props.localization;
      var state = this.state;
      var notifyChange = EventsUtils.notifyChange;

      return (
        <Popup type='none' visible={true} onClosed={closePopup.bind(this)}>
          <Popup.Header title={localization.getText('REPORTDESIGNER_LABEL_FIND_AND_REPLACE')} />
          <Popup.Body>
            <GridLayout className='form-horizontal'>
              <GridLayout.Row>
                <GridLayout.Col cols='12'>
                  <Alert type='info'>{state.message}</Alert>
                </GridLayout.Col>
              </GridLayout.Row>
              <GridLayout.Row>
                <GridLayout.Col cols='3'>{localization.getText('REPORTDESIGNER_LABEL_FIND')}</GridLayout.Col>
                <GridLayout.Col cols='9'>
                  <Input
                    value={state.searchText}
                    onChange={notifyChange(onChangeSearchText.bind(this), EventsUtils.INPUT)}
                  />
                </GridLayout.Col>
              </GridLayout.Row>
              <GridLayout.Row>
                <GridLayout.Col cols='3'>{localization.getText('REPORTDESIGNER_LABEL_REPLACE_WITH')}</GridLayout.Col>
                <GridLayout.Col cols='9'>
                  <Input
                    value={state.replaceText}
                    onChange={notifyChange(onChangeReplaceText.bind(this), EventsUtils.INPUT)}
                  />
                </GridLayout.Col>
              </GridLayout.Row>
            </GridLayout>
          </Popup.Body>
          <Popup.Footer>
            <Popup.ConfirmationButton
              label={localization.getText('REPORTDESIGNER_LABEL_FIND')}
              onClick={this.handleClick.bind(this, 'searchCode')}
            />
            <Popup.ConfirmationButton
              label={localization.getText('REPORTDESIGNER_LABEL_REPLACE')}
              onClick={this.handleClick.bind(this, 'replaceCode')}
            />
            <Popup.ConfirmationButton type='cancel'>
              {localization.getText('COMMON_LABEL_CANCEL')}
            </Popup.ConfirmationButton>
          </Popup.Footer>
        </Popup>
      );

      function closePopup(type) {
        this.setState(this.setupPopupState());
      }

      function onChangeSearchText(value) {
        this.setState({ searchText: value });
      }

      function onChangeReplaceText(value) {
        this.setState({ replaceText: value });
      }
    },

    render: function() {
      return (
        <span>
          <a className='btn' title='Find and Replace' onClick={showPopup.bind(this)}>
            <span className='icon-search-replace' />
          </a>
          <span className='u_inlineBlock'>{this.state.activePopup ? this.renderPopupContent() : null}</span>
        </span>
      );

      function showPopup() {
        this.setState({ activePopup: true });
      }
    }
  });
  module.exports = connect()(FormSearchPopup);
})();



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartForm/Izenda.FormSearchPopup.jsx